import React from 'react';
import {Box, Button, Card, Skeleton, Typography} from "@mui/material";
import {formatCurrency} from "../../utils/currencyUtil";
import {Property} from "../../redux/residentPortalApi";

interface OwnProps {
  purpose: 'levies' | 'internet' | 'pedalCourt' | 'pedalCourtInvoiceBalance';
  property: Property;
  outstandingLeviesBalance?: number | null;
  handleOpenDialog: () => void;
  title?: string;
}

const WalletCard = (props: OwnProps) => {
  const { purpose, property, handleOpenDialog, outstandingLeviesBalance, title } = props;

  const isInternet = purpose === 'internet';
  const isPadelCourt = purpose === 'pedalCourt' || purpose === 'pedalCourtInvoiceBalance';

  const balance = isInternet
    ? ((property?.internetWalletBalance ?? 0) / 100)
    : isPadelCourt
    ? ((property as any)?.pedalCourtInvoiceBalance ?? 0)
    : (property?.walletBalance ?? 0);

  const isBalanceNegative = balance < 0;
  return (
    <React.Fragment>
      {property && balance !== undefined ? (
        <Card sx={{
          p: purpose === 'internet' ? 2 : 3,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
          backgroundColor: '#ffffff',
          transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
          }
        }}>
          {purpose === 'internet' ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <Box>
                <Typography sx={{
                  fontSize: '0.95rem',
                  fontWeight: 500,
                  color: 'text.secondary',
                  mb: 0.5
                }}>
                  Internet Wallet Balance
                </Typography>
                <Typography sx={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: isBalanceNegative ? '#F44336' : 'inherit'
                }}>
                  {formatCurrency(balance)}
                </Typography>
              </Box>
              {/* <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenDialog}
                sx={{
                  borderRadius: 1.5,
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Make a Payment
              </Button> */}
            </Box>
          ) : (
            <>
              <Typography sx={{
                fontSize: '1.2rem',
                fontWeight: 400,
                color: 'text.secondary',
                mb: 1
              }}>
                {`${isBalanceNegative ? 'Debit' : 'Credit'} Balance`}
              </Typography>
              <Typography sx={{
                fontSize: '2rem',
                fontWeight: 600,
                mb: 2,
                color: isBalanceNegative ? '#F44336' : 'inherit'
              }}>
                {formatCurrency(balance)}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleOpenDialog}
                  disabled={outstandingLeviesBalance === null}
                  sx={{
                    borderRadius: 1.5,
                    textTransform: 'none',
                    fontWeight: 500
                  }}
                >
                  Make a Payment
                </Button>
              </Box>
            </>
          )}
        </Card>
      ) : (
        <Skeleton variant="text" width={100} height={40} animation="wave" />
      )}
    </React.Fragment>
  );
};

export default WalletCard;